import { Icon, Loader } from '@mairistem/composants';
import { ListeTable } from '@mairistem/liste';
import dayjs from 'dayjs';
import _ from 'lodash';

import type { ReglementType } from '@/types';
import { formatMonetaire, utils_string } from '@/utils';

interface ReglementTicketListeTableRowProps {
  item: ReglementType;
  rowProps: Record<string, unknown>;
  loadingRecu: boolean;
  selectedRecu: number;
  onRecuOpen: (identifiant: number) => void;
}

const ReglementTicketListeTableRow = (props: ReglementTicketListeTableRowProps) => {
  const { item, rowProps, loadingRecu, selectedRecu, onRecuOpen } = props;

  const {
    identifiant,
    identifiantRecu,
    numeroRecu,
    dateCreationRecu,
    type,
    nombre,
    montantUnitaire,
    dateValidite,
    dateAnnulationRecu,
    payeur,
    montant,
  } = item;

  const { civilite, prenom, nom } = payeur || {};

  const identite = `${civilite?.abreviation || ''} ${utils_string.toOfficialLastname(nom || '')} ${utils_string.toOfficialFirstname(prenom || '')}`;

  return (
    <ListeTable.Row key={identifiant} {...rowProps}>
      <ListeTable.Cell
        name="numeroRecu"
        {...(dateAnnulationRecu && {
          title: `Annulé le ${dayjs(dateAnnulationRecu).format('DD/MM/YYYY')}`,
        })}
        style={{ width: 175 }}
        textAlign="right"
      >
        <div
          {...(dateAnnulationRecu && { className: 'unselectable' })}
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <div className="textEllipsis" style={{ paddingRight: 10, flex: 1 }}>
            <span
              {...(!_.isNil(dateAnnulationRecu) && {
                style: { color: 'red', fontStyle: 'italic' },
              })}
            >
              {numeroRecu}
            </span>
          </div>
          {loadingRecu && identifiantRecu === selectedRecu ? (
            <Loader
              style={{
                position: 'relative',
                left: 0,
                transform: 'none',
              }}
              size="mini"
              active
            />
          ) : (
            <Icon
              data-testid="button-voir-recu"
              className="liste-table-row-icon"
              name="eye"
              style={{ float: 'right' }}
              fitted
              onClick={() => onRecuOpen(identifiantRecu)}
              link
              title=""
            />
          )}
        </div>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="dateRecu"
        textAlign="center"
        style={{ width: 120 }}
        {...(dateAnnulationRecu && {
          title: `Annulé le ${dayjs(dateAnnulationRecu).format('DD/MM/YYYY')}`,
        })}
      >
        <span {...(dateAnnulationRecu && { style: { color: 'red', fontStyle: 'italic' } })}>
          {dayjs(dateCreationRecu).format('DD/MM/YYYY')}
        </span>
      </ListeTable.Cell>
      <ListeTable.Cell
        name="nomPayeur"
        // @ts-expect-error
        title={identite}
      >
        {identite}
      </ListeTable.Cell>
      <ListeTable.Cell name="type">{type}</ListeTable.Cell>
      <ListeTable.Cell name="nombre">{nombre}</ListeTable.Cell>
      <ListeTable.Cell name="montantUnitaire" textAlign="right" style={{ width: 170 }}>
        {formatMonetaire(montantUnitaire)}
      </ListeTable.Cell>
      <ListeTable.Cell name="dateValidite" textAlign="center" style={{ width: 140 }}>
        {dateValidite ? dayjs(dateValidite).format('DD/MM/YYYY') : ''}
      </ListeTable.Cell>
      <ListeTable.Cell
        name="montant"
        textAlign="right"
        // @ts-expect-error
        title={formatMonetaire(montant)}
        style={{ width: 140 }}
      >
        {formatMonetaire(montant)}
      </ListeTable.Cell>
    </ListeTable.Row>
  );
};

export default ReglementTicketListeTableRow;
